(function() {
  'use strict';

  const engagement = document.getElementById('DleEngagement');
  if (!engagement) return;

  const accountDialog = document.getElementById('DleAccountPrompt');
  const offerDialog = document.getElementById('DleOfferPrompt');
  const signedIn = engagement.dataset.customerSignedIn === 'true';
  const hasActiveMembership = engagement.dataset.customerHasActiveMembership === 'true';
  const pageType = (engagement.dataset.pageType || '').trim().toLowerCase();
  const isMembershipPage = engagement.dataset.isMembershipPage === 'true';
  const isMemberLibraryPage = engagement.dataset.isMemberLibraryPage === 'true';
  const autoCloseMs = 8000;
  const accountDelayMs = 1200;
  const offerDelayMs = 8000;
  const accountSuppressionMs = 14 * 24 * 60 * 60 * 1000;
  const offerSuppressionMs = 3 * 24 * 60 * 60 * 1000;
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  let activeDialog = null;
  let previousFocus = null;
  let closeTimer = null;
  let closeDeadline = 0;
  let remainingCloseTime = autoCloseMs;
  let interactionStarted = false;
  let settingInitialFocus = false;
  let closingDialog = false;
  let inertedElements = [];

  const automaticOfferSuppressedPageTypes = new Set([
    'cart',
    'challenge',
    'checkout',
    'password',
    'policy'
  ]);

  function getStorage(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function setStorage(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {
      return;
    }
  }

  function isSuppressed(key, duration) {
    const stored = Number(getStorage(window.localStorage, key) || 0);
    return stored > 0 && Date.now() - stored < duration;
  }

  function getFocusable(dialog) {
    return Array.from(dialog.querySelectorAll(focusableSelector)).filter(function(element) {
      return !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.offsetParent !== null;
    });
  }

  function getDialogPanel(dialog) {
    return dialog ? dialog.querySelector('[role="dialog"][aria-modal="true"]') : null;
  }

  function shouldSuppressAutomaticOffer() {
    const isCustomerAccountPage = pageType === 'account' ||
      pageType.indexOf('customers/') === 0 ||
      pageType.indexOf('customers_') === 0;
    const isPolicyPage = pageType === 'policy' || pageType.indexOf('policy/') === 0;

    return hasActiveMembership ||
      isMembershipPage ||
      isMemberLibraryPage ||
      isCustomerAccountPage ||
      isPolicyPage ||
      automaticOfferSuppressedPageTypes.has(pageType);
  }

  function hasOtherOpenModal() {
    return Array.from(document.querySelectorAll('[role="dialog"][aria-modal="true"]')).some(function(dialog) {
      if (engagement.contains(dialog) || dialog.hidden || dialog.getAttribute('aria-hidden') === 'true') return false;
      const styles = window.getComputedStyle(dialog);
      return styles.display !== 'none' && styles.visibility !== 'hidden';
    });
  }

  function isolateDialogFromPage() {
    inertedElements = Array.from(document.body.children).filter(function(element) {
      return element !== engagement && !element.hasAttribute('aria-hidden');
    });

    inertedElements.forEach(function(element) {
      element.setAttribute('aria-hidden', 'true');
    });
  }

  function restorePageIsolation() {
    inertedElements.forEach(function(element) {
      element.removeAttribute('aria-hidden');
    });
    inertedElements = [];
  }

  function pauseAutoClose() {
    if (!closeTimer) return;
    window.clearTimeout(closeTimer);
    closeTimer = null;
    remainingCloseTime = Math.max(closeDeadline - Date.now(), 0);
  }

  function startAutoCloseTimer(duration) {
    if (interactionStarted) return;
    window.clearTimeout(closeTimer);
    closeDeadline = Date.now() + duration;
    closeTimer = window.setTimeout(function() {
      if (activeDialog && !interactionStarted) {
        closeDialog(activeDialog, 'auto');
      }
    }, duration);
  }

  function resumeAutoClose() {
    if (interactionStarted || remainingCloseTime <= 0) return;
    startAutoCloseTimer(remainingCloseTime);
  }

  function markInteraction() {
    interactionStarted = true;
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function closeDialog(dialog, reason) {
    if (!dialog || activeDialog !== dialog || closingDialog) return;
    closingDialog = true;

    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    const panel = getDialogPanel(dialog);
    const dialogType = dialog.dataset.dleDialog;

    if (dialogType === 'account') {
      setStorage(window.localStorage, 'dle-account-prompt-dismissed-at', String(Date.now()));
    } else if (dialogType === 'offer') {
      setStorage(window.localStorage, 'dle-offer-prompt-dismissed-at', String(Date.now()));
    }

    dialog.classList.remove('is-active');

    window.setTimeout(function() {
      dialog.hidden = true;
      dialog.setAttribute('aria-hidden', 'true');
      if (panel) {
        panel.hidden = true;
        panel.setAttribute('aria-hidden', 'true');
      }

      restorePageIsolation();
      activeDialog = null;
      closingDialog = false;

      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
      }
      previousFocus = null;

      if (reason === 'auto' && dialog === accountDialog && !shouldSuppressAutomaticOffer() && !isSuppressed('dle-offer-prompt-dismissed-at', offerSuppressionMs)) {
        // Suppress automatic chained popup
      }
    }, 220);
  }

  function openDialog(dialog) {
    if (!dialog || activeDialog || hasOtherOpenModal()) return;

    activeDialog = dialog;
    interactionStarted = false;
    settingInitialFocus = true;
    previousFocus = document.activeElement;
    remainingCloseTime = autoCloseMs;

    isolateDialogFromPage();

    dialog.hidden = false;
    dialog.setAttribute('aria-hidden', 'false');

    const panel = getDialogPanel(dialog);
    if (panel) {
      panel.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
    }

    window.requestAnimationFrame(function() {
      dialog.classList.add('is-active');
      const focusables = getFocusable(dialog);
      const initialTarget = focusables[0] || panel;

      if (initialTarget && typeof initialTarget.focus === 'function') {
        initialTarget.focus();
      }
      settingInitialFocus = false;
      startAutoCloseTimer(autoCloseMs);
    });
  }

  function handleKeydown(event) {
    if (!activeDialog) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeDialog(activeDialog, 'manual');
      return;
    }

    if (event.key !== 'Tab') {
      markInteraction();
      return;
    }

    const focusables = getFocusable(activeDialog);
    if (!focusables.length) {
      event.preventDefault();
      return;
    }

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function bindDialogEvents(dialog) {
    if (!dialog) return;

    dialog.addEventListener('click', function(event) {
      const closeTrigger = event.target.closest('[data-dle-close]');
      if (closeTrigger) {
        event.preventDefault();
        closeDialog(dialog, 'manual');
        return;
      }

      markInteraction();
    });

    dialog.addEventListener('mouseenter', pauseAutoClose);
    dialog.addEventListener('mouseleave', resumeAutoClose);
    dialog.addEventListener('input', markInteraction);
    dialog.addEventListener('change', markInteraction);

    dialog.addEventListener('focusin', function(event) {
      if (settingInitialFocus) return;
      markInteraction();
    });

    const emailForm = dialog.querySelector('#DleOfferEmailForm');
    if (emailForm) {
      emailForm.addEventListener('submit', function() {
        markInteraction();
      });
    }
  }

  bindDialogEvents(accountDialog);
  bindDialogEvents(offerDialog);
  document.addEventListener('keydown', handleKeydown);

  // Manual trigger hooks available to UI buttons
  window.openAccountDialog = function() { openDialog(accountDialog); };
  window.openOfferDialog = function() { openDialog(offerDialog); };

  // Automatic popups disabled to provide a seamless, non-intrusive, minimalist user experience.
})();
